/* eslint-disable react/prefer-es6-class, react/prop-types, react/sort-comp, react/jsx-no-bind */
import React from 'react';
import * as Paths from 'es6/core/paths';
import { t } from 'es6/services/localization';
import PanelMixin from 'es6/components/home/panel-mixin';
import ProgressBar from 'es6/components/common/progress-bar';
import { relativeTime } from 'es6/helpers/time';
import { ContentFigureSizes, ContentFigure } from 'es6/components/common/content-figure';
import Popover from 'es6/components/common/popover';

const FocusedPanel = React.createClass({
  displayName: 'FocusedPanel',

  mixins: [PanelMixin],

  getInitialState() {
    return {
      searchBy: '',
      sortBy: 'recommended',
    };
  },

  getFilteredGoals() {
    return this.props.goals.filter((goal) => {
      const aggregate = this.props.aggregateMemories[goal.id];
      return aggregate.enrolled && aggregate.focused;
    })
      .filter(this.filterBy)
      .sort(this.sortBy);
  },

  getNoCoursesMessage() {
    return t('course-tabs.now-studying-no-courses');
  },

  render() {
    return (
      <div className="now-studying" style={this.getPanelStyle()}>
        <header className="content-details course-filters">
          <div className="details-primary">
            <div className="filter">
              <label htmlFor="sort">{t('sort-by')} </label>
              <select value={this.state.sortBy} onChange={this.sortByChanged}>
                <option value="recommended">{t('sort.recommended')}</option>
                <option value="study-progress">{t('study progress')}</option>
              </select>
            </div>
          </div>

          {this.renderSearchBox()}
        </header>

        <section className="courses">
          {this.renderGoals()}
        </section>

        {this.renderPagination()}
      </div>
    );
  },

  renderGoal(goal) {
    const aggregate = this.props.aggregateMemories[goal.id];
    let progress = aggregate.items.progress;

    return (
      <article key={goal.id} className="content-course">
        <div className="content-columns">
          <ContentFigure size={ContentFigureSizes.SMALL} imgSrc={goal.icon} />

          <section className="content-column course-details">
            <h2 className="course-title ellipsis">
              <a href={Paths.course(goal.id)} title={goal.title}>{goal.title}</a>
            </h2>

            <ProgressBar progress={progress} showProgressTag />

            <div className="study-stats">
              <ul className="content-columns content-stats">
                {this.renderStats(goal, aggregate)}

                <li className="content-column course-settings">
                  <div className="details-secondary">
                    <Popover align="left" content={this.renderSettings(goal)}>
                      <span className="btn gear">{t('settings.label')}</span>
                    </Popover>
                  </div>
                </li>
              </ul>
            </div>
          </section>

          {this.renderLauncher(goal)}

          <aside className="content-column course-actions">
            <h4 className="details">{t('next-study-time')}</h4>
            {this.renderNextStudyTime(aggregate)}

            <div className="weak-items">
              <span className="primary">{t('weak-items')} </span>
              <span className="secondary weak-items">{aggregate.items.eligibleItemsCount}</span>
            </div>
          </aside>
        </div>
      </article>
    );
  },

  renderNextStudyTime(aggregateMemory) {
    if (!aggregateMemory.items.seeNextAt) {
      return (<div className="time-to-start">{t('not-started')}</div>);
    } else {
      let className = 'next-study-time';

      if (aggregateMemory.items.isReadyToStudy()) {
        className += ' urgent';
      }

      return (<div className={className}>{relativeTime(aggregateMemory.items.seeNextAt)}</div>);
    }
  },

  renderSettings(goal) {
    return (
      <aside className="content-menu course-settings-menu">
        <ul className="menu-category languages">
          <li className="menu-item inside move-to-saved-courses" onClick={this.props.onUnfocus.bind(this, goal)}>{t('move-to-saved')}</li>
          <li className="menu-item inside remove-from-studying" onClick={this.props.onUnenroll.bind(this, goal)}>{t('remove-from-studying')}</li>
        </ul>
      </aside>
    );
  },
});

export default FocusedPanel;
